import { render, staticRenderFns } from "./downTops.vue?vue&type=template&id=28e3f658"
import script from "./downTops.vue?vue&type=script&lang=js"
export * from "./downTops.vue?vue&type=script&lang=js"
import style0 from "./downTops.vue?vue&type=style&index=0&id=28e3f658&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports